import { axiosInstance as request } from '@api/rest.service'

const api = '/settings'

/**
 * @description GET /settings
 * @returns {AxiosPromise<any>}
 */
export const GET_SETTINGS = () => request.get(api)

/**
 * @description PATCH /settings
 * @returns {AxiosPromise<any>}
 */
export const MODIFY_SETTINGS = payload => request.patch(api, payload)
